"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const react_draggable_1 = __importDefault(require("react-draggable"));
const better_react_mathjax_1 = require("better-react-mathjax");
// import {ResizableBox} from "react-resizable";
function PaperComponent(props) {
    return ((0, jsx_runtime_1.jsx)(react_draggable_1.default, Object.assign({ handle: '#draggable-dialog-title', cancel: '[class*="MuiDialogContent-root"]' }, { children: (0, jsx_runtime_1.jsx)(Paper_1.default, Object.assign({}, props)) })));
}
function ExplainDialog({ description, onClose = null }) {
    const [open, setOpen] = React.useState(true);
    const closeDialog = () => {
        setOpen(false);
        if (onClose) {
            onClose();
        }
    };
    const handleClose = (e, reason) => {
        if (reason !== 'backdropClick')
            closeDialog();
    };
    return ((0, jsx_runtime_1.jsxs)(Dialog_1.default, Object.assign({ open: open, hideBackdrop: true, disableEnforceFocus: true, disableEscapeKeyDown: true, maxWidth: 'lg', style: { pointerEvents: 'none' }, PaperProps: { style: { pointerEvents: 'auto' } }, onClose: handleClose, PaperComponent: PaperComponent, "aria-labelledby": 'draggable-dialog-title' }, { children: [(0, jsx_runtime_1.jsxs)(DialogTitle_1.default, Object.assign({ style: { cursor: 'move', height: 45 }, id: 'draggable-dialog-title' }, { children: ["Answer & Explaination", (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": 'close', onClick: () => closeDialog(), sx: {
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] })), (0, jsx_runtime_1.jsx)(DialogContent_1.default, Object.assign({ sx: { padding: '5px' } }, { children: (0, jsx_runtime_1.jsx)(better_react_mathjax_1.MathJax, Object.assign({ inline: true, dynamic: true }, { children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: description } }) })) }))] })));
}
exports.default = ExplainDialog;
